import React from 'react';

const CyberBackground = () => {
  return (
    <div className="cyber-bg">
      <div className="cyber-grid"></div>
      <div className="cyber-particles"></div>
    </div>
  );
};

export default CyberBackground;
